import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import { BREAKPOINTS_EM_MIN_WIDTH_MEDIA_QUERY } from '../themes';
/**
 * Default usage:
 * Media queries are in min-width, Given example breakpoints ['S', 'MD', 'XL']
 * Media queries are in min-width, Given example breakpoints ['S', 'MD', 'XL']
 * if you want to target narrower than M that would be !match.MD
 * if you want to target between M and XL that would be match.MD && !match.XL
 * if you want to target above XL that would be match.XL
 */

export var useMediaQuery = function useMediaQuery() {
  var queries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BREAKPOINTS_EM_MIN_WIDTH_MEDIA_QUERY;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      match = _useState2[0],
      setMatch = _useState2[1];

  useEffect(function () {
    var mqLists = Object.keys(queries).reduce(function (watchers, key) {
      var list = window.matchMedia(queries[key]);

      var handler = function handler(_ref) {
        var matches = _ref.matches;

        if (typeof matches !== 'undefined') {
          setMatch(function (current) {
            return _extends({}, current, _defineProperty({}, key, matches));
          });
        }
      };

      handler(list);
      if (list.addEventListener) list.addEventListener('change', handler);else list.addListener(handler);
      return [].concat(_toConsumableArray(watchers), [{
        list: list,
        handler: handler
      }]);
    }, []);
    return function () {
      mqLists.forEach(function (_ref2) {
        var list = _ref2.list,
            handler = _ref2.handler;
        if (list.removeEventListener) list.removeEventListener('change', handler);else list.removeListener(handler);
      });
    };
  }, [queries]);
  return match;
};